import { useTranslation } from 'react-i18next';

import { useAlertDialog } from '@/components/ui/alert-dialog';
import api from '@/services/api/api';
import PermissionFormData from '@/types/Permission/PermissionFormData';
import { useMutation } from '@tanstack/react-query';

export const useUpdatePermissionMutation = () => {
  const { alert } = useAlertDialog();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (data: PermissionFormData) => {
      if (!data?.id) return alert({ title: t('record-not-found'), type: 'error' });
      const response = await api.put(`admin/permission/${data.id}`, data);
      return response.data;
    },
    mutationKey: ['updatePermission'],
  });
};
